const KEYCODES = {
  BACKSPACE: 8,
  DELETE: 46,
};

function calculateNewValue({
  lastVal,
  currVal,
  selectStart,
  lastDisplayValue,
  keycode,
  maxLength,
  validCharRegex,
}) {
  let newVal = currVal;
  const maxLengthExceeded = newVal.length > maxLength;
  const backspaceInvalidChar = newVal.length === lastVal.length && keycode === KEYCODES.BACKSPACE;
  const deleteInvalidChar = newVal.length === lastVal.length && keycode === KEYCODES.DELETE;

  if (maxLengthExceeded) {
    return lastVal;
  } else if (backspaceInvalidChar || deleteInvalidChar) {
    const lastDispArr = lastDisplayValue.split('');
    const arrUpToCursor = lastDispArr.slice(0, selectStart);
    const arrAfterCursor = lastDispArr.slice(selectStart);
    let newArr = undefined;

    if (backspaceInvalidChar) {
      newArr = rmLastValidCharFromArray(arrUpToCursor, validCharRegex).concat(arrAfterCursor);
    } else {
      newArr = arrUpToCursor.concat(rmNextValidCharFromArray(arrAfterCursor, validCharRegex));
    }
    newVal = rmAllInvalidCharsFromArray(newArr, validCharRegex).join('');
  }

  return newVal;
}

export function formatValueToTemplate(value, template, wildcards) {
  const wildRegex = new RegExp(`[${wildcards}]`, "g");
  const wildcard = "·";
  template = template.replace(wildRegex, wildcard);

  const templateArr = template.split("");
  const valueArr = value.split("");
  const originalInputLength = valueArr.length;

  const resultArr = [];
  let useResult = true;

  for (let i = 0; i < templateArr.length; i++) {
    if (templateArr[i] === wildcard && valueArr.length) {
      resultArr.push(valueArr.shift());
    } else if (templateArr[i] !== wildcard) {
      if (i === 0) useResult = false;
      else if (!(valueArr.length === originalInputLength)) useResult = true;
      resultArr.push(templateArr[i]);
    } else {
      break;
    }
  }
  
  return useResult ? resultArr.join("") : value;
};

function idxFromKey(fields, key) {
  for (let i = 0; i < fields.length; i++) {
    if (key === fields[i].key) return i;
  }
  return -1;
}

function nextSelectionPosition({
  selectStart,
  lastDisplayValue,
  currDisplayValue,
  keycode,
  validCharRegex,
}) {
  let pos = selectStart;
  const backspacePressed = keycode === KEYCODES.BACKSPACE;
  const deletePressed = keycode === KEYCODES.DELETE;

  const nextCharacterIsValid = !!currDisplayValue.charAt(selectStart + 1).match(validCharRegex) || pos + 1 >= currDisplayValue.length;
  const nextCharacterWasValid = !!lastDisplayValue.charAt(selectStart).match(validCharRegex) || pos + 1 >= lastDisplayValue.length;
  const prevCharacterIsValid = !!currDisplayValue.charAt(Math.max(0, selectStart - 2)).match(validCharRegex) || pos - 2 >= currDisplayValue.length;

  const valueChanged = lastDisplayValue !== currDisplayValue;
  const backspaceCharIsValid = backspacePressed && prevCharacterIsValid;
  const deleteCharWasInvalid = deletePressed && !nextCharacterWasValid;

  if ((nextCharacterIsValid || backspaceCharIsValid) && valueChanged && !deletePressed) {
    pos = backspacePressed ? prevValidCharIndexFromArray(lastDisplayValue.split(''), pos, validCharRegex) : selectStart + 1;
  } else if (!nextCharacterIsValid && valueChanged) {
    const startIdx = backspacePressed ? pos : pos + 1;
    pos = nextValidCharIndexFromArray(currDisplayValue.split(''), startIdx, validCharRegex);
    if (!nextCharacterWasValid && !deleteCharWasInvalid) pos += 1;
  }
  return pos;
}

function nextValidCharIndexFromArray(arr, startIdx, validCharRegex) {
  let idx = arr.length;
  if (startIdx < arr.length) {
    for (let i = startIdx; i < arr.length; i++) {
      if (!!arr[i].match(validCharRegex)) {
        idx = i;
        break;
      }
    }
  }
  return idx;
}

function prevValidCharIndexFromArray(arr, startIdx, validCharRegex) {
  let idx = startIdx;
  if (startIdx > 0 && startIdx <= arr.length) {
    for (let i = startIdx - 1; i >= 0; i--) {
      if (!!arr[i].match(validCharRegex)) {
        idx = i;
        break;
      }
    }
  }
  return idx;
}

export function removeNonDigits(input) {
  return input.replace(/\D/g, '');
}

function rmAllInvalidCharsFromArray(arr, validCharRegex) {
  const cleanArr = [];
  for (let i = 0; i < arr.length; i++) {
    if (!!arr[i].match(validCharRegex)) cleanArr.push(arr[i]);
  }
  return cleanArr;
}

function rmLastValidCharFromArray(arr, validCharRegex) {
  const newArr = [];
  let hasSkipped = false;
  for (let i = arr.length - 1; i >= 0; i--) {
    if (!arr[i].match(validCharRegex) || hasSkipped) {
      newArr.unshift(arr[i]);
    } else if (!!arr[i].match(validCharRegex)) {
      hasSkipped = true;
    }
  }
  return newArr;
}

function rmNextValidCharFromArray(arr, validCharRegex) {
  const newArr = [];
  let hasSkipped = false;
  arr.forEach((val) => {
    if (!val.match(validCharRegex) || hasSkipped) {
      newArr.push(val);
    } else if (!!val.match(validCharRegex)) {
      hasSkipped = true;
    }
  });
  return newArr;
}

export function truncate(input, limit) {
  return input.substring(0, limit);
}

export default {
  calculateNewValue,
  formatValueToTemplate,
  idxFromKey,
  nextSelectionPosition,
  removeNonDigits,
  truncate,
};
